<template>
  <div class="contain">
    <div
      style="
        margin-top: 4rem;
        font-size: 2rem;
        line-height: 2rem;
        font-weight: bold;
        color: #b62d2e;
      "
    >
      忘記密碼 Forgot Password
    </div>
    <div style="display: flex; margin-top: 0.5rem; margin-bottom: 1rem">
      <span
        style="
          width: 1rem;
          height: 1rem;
          background: #b62d2e;
          border-radius: 50%;
          margin: 0 0.5rem;
        "
      ></span>
      <span
        style="
          width: 1rem;
          height: 1rem;
          background: #de5934;
          border-radius: 50%;
          margin: 0 0.5rem;
        "
      ></span>
      <span
        style="
          width: 1rem;
          height: 1rem;
          background: #f1aa55;
          border-radius: 50%;
          margin: 0 0.5rem;
        "
      ></span>
    </div>
    <div class="col-xs-22 col-sm-13" style="text-align: center">
      請輸入您的家長電郵地址，選擇重置家長的密碼還是學生的密碼，我們將會向您發送重置後的密碼<br />
      Please enter your parent’s email address and select whether to reset the parent’s password or the child’s password. <br />We will send the new password to this email.
    </div>
    <div class="security-box">
      <el-form ref="form" :model="form" style="margin-top: 6rem">
        <el-form-item
          prop="email"
          :rules="{
            required: true,
            message: '請輸入家長電郵地址 Please enter an parent‘s e-mail address',
          }"
        >
          <div class="security-title">家長電郵地址 Parent‘s Email</div>
          <el-input v-model="form.email" placeholder="電郵地址 Email"></el-input>
          <el-radio v-model="form.type" :label="1">重置家長密碼</el-radio>
          <el-radio v-model="form.type" :label="2">重置學生密碼（使用家長電郵）</el-radio>
        </el-form-item>
      </el-form>
      <div style="display: flex; flex-direction: column; margin-top: 6rem">
        <el-button class="security-button" round @click="onConfirm"
          >確認 Confirm</el-button
        >
        <el-button class="security-button" round @click="onBackText"
          >返回 Back</el-button
        >
      </div>
    </div>
    <loadingDialog :center-dialog-visible="centerDialogVisible"></loadingDialog>
  </div>
</template>

<script>
import loadingDialog from "@/components/loadingDialog/index";
import { forgetPasswordEmail } from "@/api/security";
export default {
  components: { loadingDialog },
  data() {
    return {
      centerDialogVisible: false,
      form: {
        email: "",
        type: 1,
      },
    };
  },
  methods: {
    onConfirm() {
      this.forgetPasswordEmail();
    },
    onBackText() {
      this.$router.push({ path: "/login" });
    },
    forgetPasswordEmail() {
      forgetPasswordEmail(this.form).then(() => {
        this.$message.success(this.$t("other.forgetPasswordSuccess"));
        this.onBackText();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.contain {
  display: flex;
  flex-direction: column;
  align-items: center;
  //justify-content: center;
  //padding:0 60px;
  flex: 1;
}
.security-box {
  width: 43rem;
}
.security-title {
  color: #8e8e8e;
  font-weight: bold;
  line-height: 1.6rem;
}
.security-button {
  margin: 1.25rem 0;
  border: 0.0625rem solid #fcc03a;
  font-weight: bold;
  font-size: 1.125rem;
  color: #444444;
}
@media (min-width: $minWidth) and (max-width: $maxWidth) {
  .security-box {
    width: 27rem;
  }
}

@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .contain {
    height: 100%;
  }
  .security-box {
    width: 20rem;
    max-width: 90vw;
  }
}
::v-deep {
  .el-input__inner {
    //border-top-right-radius: 3.125rem;
    //border-bottom-right-radius: 3.125rem;
    border-radius: 0.625rem;
    //background-color: #fffbed;
    border: 0.0625rem solid #a1a1a1;
    padding-left: 0.5rem;
    height: 2.75rem;
    line-height: 2.75rem;
  }
  .el-input-group__prepend {
    border-top-left-radius: 3.125rem;
    border-bottom-left-radius: 3.125rem;
    background-color: #fffbed;
    border: 0.0625rem solid #fffbed;
    padding: 0 1.25rem;
    padding-right: 0;
  }
  .el-form-item__error {
    font-size: 14px;
    line-height: 1.6;
    padding-top: 0;
  }
  .el-input__icon {
    width: 1.75rem;
    line-height: 2.75rem;
  }
  .el-icon-circle-close {
    font-size: 1.75rem;
  }
  .el-icon-circle-check {
    color: #008000;
    font-size: 1.75rem;
  }
  .el-button + .el-button {
    margin: 0;
    margin-top: 1.125rem;
  }
  .security-button:nth-child(1) {
    background-color: #fcc03a;
  }
  .security-button:nth-last-child(1) {
    background-color: #ffffff;
  }
}
</style>
